<div style="display: block;height: 300px;">
    <app-highcharts chartTitle="Uso de Memória %" [data$]="dataSubject" height="300" yMax="100" valueSuffix=" %"></app-highcharts>
</div>